import { createMuiTheme } from '@material-ui/core/styles';


export default createMuiTheme({
  palette: {
    primary: {
      //main: '#009933',
      main: '#7BC57F',
    },
    secondary: {
      main: '#f44336',
    },
  },
  typography: {
    fontFamily: [
      '"Open Sans"',
      'Arial',
      'sans-serif',
    ].join(',')
    //"Roboto", "Helvetica", "Arial", sans-serif;
    ,
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: 'white',
      },
    },
    MuiAppBar:{
      colorPrimary:{
        color:'white',
      }
    }
  }
});